import React, { useState } from "react";
import axios from "axios";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
     const res = await axios.post(
  "https://kkblossomschool.org/KKBlossomsWebsite/admin_login.php",
  { email, password }
);

      if (res.data.status === "success") {
        localStorage.setItem("admin_id", res.data.admin_id);
        setMessage("Login successful");

        // redirect
        window.location.href = "/admin-dashboard";
      } else {
        setMessage(res.data.message);
      }
    } catch (error) {
      setMessage("Server error");
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleLogin} style={styles.form}>
        <h2>Admin Login</h2>

        <input
          type="email"
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={styles.input}
        />

       <input
  type="password"
  placeholder="Enter Password"
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  required
  autoComplete="current-password"
    style={styles.input}
/>

        <button type="submit" style={styles.button}>
          Login
        </button>

        <p>{message}</p>
      </form>
    </div>
  );
};

const styles = {
  container: {
    height: "130vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f4f4f4",
  },
  form: {
    padding: "30px",
    background: "#fff",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    width: "300px",
  },
  input: {
    width: "100%",
    padding: "10px",
    margin: "10px 0",
  },
  button: {
    width: "100%",
    padding: "10px",
    background: "#4CAF50",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  },
};

export default AdminLogin;